import { host } from '../fromWindow';
import { DEFAULT_BRIEF_PARAMS, BASE_URL_MARKETPLACE } from './constants';

const goToBrief = ({
  entry,
  categoryId,
  serviceId,
  origin,
  target,
  isDirect = false,
}) => {
  window.open(
    `//${host}${BASE_URL_MARKETPLACE}/dynamic-brief?entry=${entry}&serviceType=${categoryId}&innerType=${serviceId}&origin=${origin}${
      isDirect ? '&isDirect=true' : ''
    }`,
    target,
  );
};
const goToAutoBrief = ({
  entry = DEFAULT_BRIEF_PARAMS.entry,
  categoryId = DEFAULT_BRIEF_PARAMS.categoryId,
  serviceId = DEFAULT_BRIEF_PARAMS.serviceId,
  origin = DEFAULT_BRIEF_PARAMS.origin,
  target = '_self',
}) => {
  window.sessionStorage.removeItem('arenaBriefExpertGuid');
  window.sessionStorage.removeItem('arenaBriefproviderName');
  goToBrief({ entry, categoryId, serviceId, origin, target });
};

const goToDirectBrief = ({
  guid = null,
  name = null,
  entry = DEFAULT_BRIEF_PARAMS.entry,
  categoryId = DEFAULT_BRIEF_PARAMS.categoryId,
  serviceId = DEFAULT_BRIEF_PARAMS.serviceId,
  origin = DEFAULT_BRIEF_PARAMS.origin,
  target = '_self',
}) => {
  window.sessionStorage.setItem('arenaBriefExpertGuid', guid);
  window.sessionStorage.setItem('arenaBriefproviderName', name);
  goToBrief({ entry, categoryId, serviceId, origin, target, isDirect: true });
};

export { goToDirectBrief, goToAutoBrief };
